import React from 'react';

import { Typography } from '@mui/material';
import { TypographyProps } from '@mui/material';

interface StatProps {
  variant?: TypographyProps['variant'];
  label: string;
  total: number | undefined;
  gains?: number | undefined;
  gainLabel?: string;
}

const Stat: React.FC<StatProps> = ({
  variant,
  label,
  total,
  gains,
  gainLabel,
}) => {
  return (
    <Typography
      variant={variant ? variant : 'body2'}
      component='div'
      sx={{ fontWeight: variant ? 'bold' : 'normal' }}
    >
      {label}: {total}{' '}
      {gains ? `(${gains} ${gainLabel ? gainLabel : 'acres'})` : ''}
    </Typography>
  );
};

export default Stat;
